import axios from "axios";

export default {
    read: () => axios.get("/api/configuration/read"),
    update: (obj) => axios.post("/api/configuration/update", obj),
    upload_icon: (obj) => axios.post("/upload_icon", obj, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }),
};
